import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'

interface Props {
  data: any
  status: number
}

export const moveError = ({ status, data }: Props) => {
  if (status === 422 && data.errors !== undefined) {
    showErrorMessageToast(
      `The following folders already exist in the destination folder: ${data.errors
        .map((title: string) => `'${title}'`)
        .join(',')}. Please rename them before moving.`,
    )
  } else if (status === 403) {
    showErrorMessageToast('You are not authorized to move items into the destination folder')
  } else {
    showErrorMessageToast('There was a problem moving your files. Please try again')
  }
}
